// Icons for dev→shop announcements (dev picks one; symbolizes updates, info, etc.)
import { Megaphone, Bell, Info, AlertTriangle, RefreshCw, Sparkles, Calendar, Gift, Wrench, PartyPopper } from "lucide-react";

export const ANNOUNCEMENT_ICONS = {
  megaphone: Megaphone,
  bell: Bell,
  info: Info,
  warning: AlertTriangle,
  update: RefreshCw,
  sparkles: Sparkles,
  calendar: Calendar,
  gift: Gift,
  wrench: Wrench,
  party: PartyPopper,
};

export const ANNOUNCEMENT_ICON_KEYS = Object.keys(ANNOUNCEMENT_ICONS);
